var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9048_133201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0301 1.96967H1.97266V30.0271H30.0301V1.96967Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.185529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7615 10.062C25.4299 9.80059 25.0345 9.4435 24.314 9.35422C23.638 9.26495 22.9494 9.7177 22.4839 10.0174C22.0184 10.3171 21.1384 11.1971 20.7749 11.4649C20.4114 11.7327 19.4804 11.9814 17.9819 12.8805C16.4834 13.7796 10.6041 17.5546 10.6041 17.5546L12.1345 17.5738L5.31142 21.0873H5.99373L5.01172 21.8334C5.01172 21.8334 5.87895 22.063 6.60589 21.6038V21.8143C6.60589 21.8143 14.7298 18.6132 16.2985 19.4422L15.342 19.7227C15.4249 19.7227 16.968 19.8248 16.968 19.8248C17.0055 20.1443 17.1129 20.4517 17.2826 20.725C17.4523 20.9983 17.6802 21.2309 17.95 21.4062C18.881 22.0183 18.9002 22.3563 18.9002 22.3563C18.9002 22.3563 18.4155 22.554 18.4155 22.8027C18.4155 22.8027 19.1297 22.5859 19.7929 22.605C20.2138 22.621 20.6313 22.6873 21.0363 22.8027C21.0363 22.8027 20.9853 22.5348 20.3413 22.3563C19.6972 22.1778 19.0596 21.4763 18.7471 21.0937C18.5557 20.8502 18.431 20.561 18.3851 20.2547C18.3393 19.9484 18.374 19.6354 18.4857 19.3465C18.7089 18.7662 19.4868 18.4474 21.0937 17.6184C22.9876 16.6364 23.4212 15.9095 23.689 15.3419C23.9569 14.7744 24.3522 13.6457 24.5754 13.1165C24.856 12.4342 25.2003 12.0707 25.4873 11.8539C25.7742 11.6371 27.0496 11.1588 27.0496 11.1588C27.0496 11.1588 26.0739 10.3107 25.7615 10.062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9048_133201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsm);
export default __webpack_public_path__ + "static/media/KSM.0a5a534b5de38b52545f449862cfd6f5.svg";
export { ForwardRef as ReactComponent };